<template>
    <div>
        <!-- 电子健康卡的卡片布局 -->
        <div v-if="voucher.cardType === '01'" class="electron-health" @click="selectVoucher(voucher)">
            <img class="card-img" src="../../../static/img/icon-card-2.png" alt="">
            <div class="health-content">
                <div class="health-content-area">
                    <!-- 卡片顶部文字行 -->
                    <div class="health-content-top-tips">
                        <div class="top-tips-left">
                          四川省卫生健康委员会
                        </div>
                        <div class="top-tips-right">
                            <img src="../../../static/img/icon-red-ten.png" alt="">
                            <span>电子健康卡</span>
                        </div>
                    </div>
                    <div class="card-info flex-1">
                        <div class="card-info-left">
                            <h4>{{voucher.holderName}}</h4>
                            <p>{{voucher.cardNo | dotted}}</p>
                        </div>
                        <div class="card-info-right new_heanlth_cardItem_canvas">
                            <qrcode :value="voucher.qrCode" :level="qrcodeLenth" :size="94"></qrcode>
                            <img class="card-logo" src="../../../static/img/card-logo.png" alt="">
                        </div>
                    </div>
                    <div class="card-footer">
                        <p>中华人民共和国国家卫生健康委员会监制</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 居民健康卡的卡片布局 -->
        <div v-else="" class="resident-health" @click="selectVoucher(voucher)">
            <img class="card-img" src="../../../static/img/icon-card-1.png" alt="">
            <div class="health-content">
                <div class="health-content-area flex-col flex-justify-center f-middle">
                    <div class="flex-row flex-align-center item-row">
                        <span class="item-left">姓名</span>
                        <span class="item-right flex-1">{{voucher.holderName}}</span>
                    </div>
                    <div class="flex-row flex-align-center item-row">
                        <span class="item-left">卡类型</span>
                        <span class="item-right flex-1">{{voucher.cardType | cardType}}</span>
                    </div>
                    <div class="flex-row flex-align-center item-row">
                        <span class="item-left">卡号</span>
                        <span class="item-right flex-1">{{voucher.cardNo | dotted}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Qrcode from 'v-qrcode'

    /* eslint-disable */
    export default {
        components: {
            Qrcode,
        },
        props: {
            voucher: {
                type: Object
            }
        },
        computed: {
            qrcodeLenth(){
                let codeString = this.voucher.qrCode
                return codeString.split(':').length > 2 ? 'Q' : 'L'
            }
        },
        methods: {
            selectVoucher(voucher) {
                this.$emit('selected', voucher);
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../static/sass/_variable.scss';
    .electron-health{
        // margin: 0 .5rem;
        position: relative;
        .card-img{
            min-height: 8.75rem;
            width:100%;
        }
        .health-content{
            top: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            .health-content-area{
                position: relative;
                padding: 0 1rem 0 0.875rem;
                height: 100%;
                @include display-flex;
                @include flex-direction(column);
                @include justify-content(space-between);
                .health-content-top-tips{
                    @include display-flex;
                    @include justify-content(space-between);
                    @include align-items(center);
                    margin-top: 5%;
                    .top-tips-left{
                        color: #2B2B2B;
                        font-size: .65rem;
                        font-weight: bold;
                        font-family: PingFang-SC-Medium;
                    }
                    .top-tips-right{
                        @include display-flex;
                        @include align-items(center);
                        img {
                            width: 1.5rem;
                            height: 1.5rem;
                        }
                        span {
                            margin-left: 5px;
                            color: #2B2B2B;
                            font-size: .9rem;
                            font-weight: bold;
                            font-family: PingFang-SC-Medium;
                        }
                    }
                }
                .card-info{
                    @include display-flex;
                    @include justify-content(space-between);
                    @include align-items(flex-end);
                    .card-info-left{
                        color: #2B2B2B;
                        h4,p{
                            font-size: .9rem;
                            font-weight: bold;
                            font-family: PingFang-SC-Medium;
                        }
                    }
                    .card-info-right{
                        position: relative;
                        width: 3.85rem;
                        height: 3.85rem;
                        background: #fff;
                        padding: 4px;
                        .card-logo{
                            position: absolute;
                            width: .9rem;
                            height: .9rem;
                            left: 0;
                            right: 0;
                            top: 0;
                            bottom: 0;
                            margin: 1.675rem auto;
                        }
                    }
                    .qr-img{
                        width: inherit;
                        height: inherit;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .card-footer {
                    height: 2rem;
                    line-height: 2rem;
                    text-align: center;
                    color: #2B2B2B;
                    font-size: .65rem;
                    font-weight: bold;
                    font-family: PingFang-SC-Medium;
                }
            }
        }
    }

    .resident-health {
        position: relative;
        .card-img{
            min-height: 8.75rem;
            width:100%;
        }
        .health-content{
            top: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            .health-content-area{
                position: relative;
                padding: 0 2rem 0 2rem;
                height: 100%;
                .item-row {
                    padding: 5px;
                    color: #fff;
                    .item-left {
                        width: 25%;
                    }
                    .item-right {
                        @include ellipsis()
                    }
                }
            }
        }
    }
</style>
<style lang="scss">

    .new_heanlth_cardItem_canvas {
    canvas {
        width: 104%;
    }
    }
</style>



// WEBPACK FOOTER //
// VoucherItem.vue?385855c2